export default __webpack_public_path__ + "static/illustration-content-logo.url-d96ea8d29889064f2cf03ff73c283fb2.svg";